<template>
	<div class="file-upload">
		<mdb-btn icon="plus" :iconRight="true" class="file-upload-icon"></mdb-btn>

		<span class="file-upload-text">Click here</span>
		<input
			type="file"
			name="fileAttachment"
			id="FileAttachment"
			class="upload"
			@change="filesInput"
			multiple
		/>
		<div class="upload-notification-wrapper" v-if="isUploadNotification">
			<div class="upload-notification">
				<p>Uploading...</p>
			</div>
		</div>
	</div>
</template>

<script>
import { getUploadSignedUrl, uploadS3Object } from '@/services/S3Service.js'
import { mdbBtn } from 'mdbvue'
import { mapState } from 'vuex'
import NProgress from 'nprogress'

export default {
	name: 'BaseFileInput',
	data() {
		return {
			isUploadNotification: false
		}
	},
	computed: {
		...mapState({
			token: state => state.auth.token,
			user: state => state.auth.user
		})
	},
	components: {
		mdbBtn
	},
	props: {
		attachments: {
			type: Array
		},
		attachmentId: {
			type: Number,
			required: true
		}
	},
	methods: {
		async filesInput(e) {
			if (e.target.files.length > 0) {
				this.isUploadNotification = true
			}
			const files = e.target.files
			const token = sessionStorage.getItem('token')
			const user = JSON.parse(sessionStorage.getItem('user'))
			const userEmail = user.email
			NProgress.start()
			for (let i = 0; i < files.length; i++) {
				const file = files[i]
				const contentType = file.type.split('/')
				const mediatype = contentType[0]
				const subtype = contentType[1]

				const fileNameArray = file.name.split('.')
				const fileNameArrayLength = fileNameArray.length
				fileNameArray[fileNameArrayLength - 2] = `${
					fileNameArray[fileNameArrayLength - 2]
				}-${new Date().getTime()}`
				const newFileName = fileNameArray.join('.')

				var newFile = new File([file], newFileName, {
					type: `${mediatype}/${subtype}`
				})

				try {
					const response = await getUploadSignedUrl(
						userEmail,
						newFile.name,
						mediatype,
						subtype
					)
					const uploadSignedUrl = response.data.url

					await uploadS3Object(uploadSignedUrl, newFile, newFile.type)

					const attachment = {
						attachmentId: this.attachmentId,
						name: newFile.name,
						folder: userEmail
					}
					this.$emit('add')
					this.attachments.push(attachment)
					this.isUploadNotification = false
				} catch (e) {
					console.log(e)
					this.isUploadNotification = false
				}
			}
			NProgress.done()
			this.$emit('input', this.attachments)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/baseFileInput.scss';
</style>
